import { render, staticRenderFns } from "./ODownloadFileButton.vue?vue&type=template&id=1d2d8f30&scoped=true"
import script from "./ODownloadFileButton.vue?vue&type=script&lang=js"
export * from "./ODownloadFileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2d8f30",
  null
  
)

export default component.exports